import { isNil } from 'lodash'
import { Box, Grid, Typography } from '@mui/material'
import { ActivityIndicator } from 'components/Shared/ActivityIndicator'
import { SectionHeader } from 'components/SectionHeader'
import { useGetSweepstakeById } from 'hooks/api/useGetSweepstakeById'
import { type Sweepstake } from 'src/types/api'

export const LocationSweepstakeSingleDrawingSection = ({
  sweepstake,
}: {
  sweepstake: Sweepstake
}) => {
  const prizesQuery = useGetSweepstakeById({
    sweepstakeId: Number(sweepstake.id),
  })

  const prizes = prizesQuery.data

  if (prizesQuery.isPending) {
    return <ActivityIndicator />
  }

  if (prizesQuery.isError || isNil(prizesQuery.data)) {
    return <Box>An error occurred fetching the prizes.</Box>
  }

  return (
    <>
      <SectionHeader title="Prizes" showButton={false} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          rowGap: '16px',
          borderWidth: 1,
          borderColor: 'grey.300',
          borderRadius: 2,
          p: '16px',
          mb: '40px',
          mt: '15px',
        }}
      >
        {prizes?.contestWinners?.length === 0 ? (
          <Typography>No prizes</Typography>
        ) : (
          ''
        )}

        <Grid container spacing={3}>
          {prizes?.contestWinners?.length !== 0 &&
            Array.from({ length: prizes?.numLocationWinners ?? 1 }, (_, i) => {
              const winner = prizes?.contestWinners?.filter(
                (x) => x.contestId === prizes?.id
              )[i]
              return (
                <Grid item xs={12} key={i}>
                  <Typography variant="body1">
                    <strong>Winner #{i + 1}: </strong>{' '}
                    {`${String(winner?.prizeDescription)}`}
                    {Number(winner?.prizeAmount) !== 0
                      ? ` - $${Number(winner?.prizeAmount ?? 0).toFixed(2)}`
                      : ''}
                  </Typography>
                </Grid>
              )
            })}
        </Grid>
      </Box>
    </>
  )
}
